import { Container, Typography } from '@mui/material';
import { HeaderAlignment, SectionHeader as SectionHeaderType } from '@peerless/data-access/strapi';
import { formatPosition, formatSectionWidth, formatTextPosition } from '../utils';

export function SectionHeader(props: SectionHeaderType) {
  if (Object.keys(props).length === 0) return null;
  const { title, description, headerAlignment, headerWidth, textColor } = props;
  const DEFAULT_HEADER_ALIGNMENT: HeaderAlignment = 'Left';
  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: formatPosition(headerAlignment ?? DEFAULT_HEADER_ALIGNMENT),
        textAlign: formatTextPosition(headerAlignment ?? DEFAULT_HEADER_ALIGNMENT),
        color: textColor,
        padding: '0 !important',
      }}
      maxWidth={formatSectionWidth(headerWidth)}
    >
      {title && (
        <Typography
          align={formatTextPosition(headerAlignment ?? DEFAULT_HEADER_ALIGNMENT)}
          className="header-underline"
          variant="h2"
        >
          {title}
        </Typography>
      )}
      {description && <div dangerouslySetInnerHTML={{ __html: description }} />}
    </Container>
  );
}
